var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[_vm.size ? 'icon--' + _vm.size : null, _vm.extraClass ? _vm.extraClass : null, `icon-${_vm.name}`, 'icon']},[_c(_vm.name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }